import { defineMessages } from "@formatjs/intl"
import type { StockStatus } from "./StockStatus"

export const stockStatusMessages = defineMessages<StockStatus>({
	IN_STOCK: {
		defaultMessage: "In Stock",
		id: "vehicle.stockStatus.inStock",
	},
	IN_USE: {
		defaultMessage: "In Use",
		id: "vehicle.stockStatus.inUse",
	},
	INCOMING: {
		defaultMessage: "Incoming",
		id: "vehicle.stockStatus.incoming",
	},
	REMOVED: {
		defaultMessage: "Removed",
		id: "vehicle.stockStatus.removed",
	},
})
